var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "form",
      { attrs: { "data-vv-scope": "form-group" } },
      [
        _c(
          "b-form-group",
          {
            attrs: {
              label:
                "Selecciona la oficina de la que deseas asignar el expediente"
            }
          },
          [
            _c("SelectValidate", {
              directives: [
                {
                  name: "validate",
                  rawName: "v-validate",
                  value: "required",
                  expression: "'required'"
                }
              ],
              attrs: {
                options: _vm.userCompanyGroups,
                name: "office",
                "data-cy": "select-offices",
                danger: _vm.errors.has("form-group.office"),
                "danger-text": _vm.errors.first("form-group.office"),
                "data-vv-as": "oficina",
                state: _vm.errors.has("form-group.office") ? false : null
              },
              model: {
                value: _vm.groupSelected,
                callback: function($$v) {
                  _vm.groupSelected = $$v
                },
                expression: "groupSelected"
              }
            })
          ],
          1
        )
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "text-right mt-2" },
      [
        _c(
          "b-button",
          {
            staticClass: "mr-2",
            attrs: {
              "data-cy": "search-flows-button",
              variant: "primary",
              size: "sm"
            },
            on: {
              click: function($event) {
                return _vm.$emit("search-flows-office", _vm.groupSelected)
              }
            }
          },
          [_vm._v(" Buscar expedientes de oficina ")]
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }